/**
 * 本地字典集合
 */
var $DICTIONARIES = new Object();
$DICTIONARIES['001'] = '民族';
$DICTIONARIES['001001'] = '汉族';
$DICTIONARIES['001002'] = '蒙古族';
$DICTIONARIES['001003'] = '回族';
$DICTIONARIES['001004'] = '藏族';
$DICTIONARIES['001005'] = '维吾尔族';
$DICTIONARIES['001006'] = '苗族';
$DICTIONARIES['001007'] = '彝族';
$DICTIONARIES['001008'] = '壮族';
$DICTIONARIES['001009'] = '布依族';
$DICTIONARIES['001010'] = '朝鲜族';
$DICTIONARIES['001011'] = '满族';
$DICTIONARIES['001012'] = '侗族';
$DICTIONARIES['001013'] = '瑶族';
$DICTIONARIES['001014'] = '白族';
$DICTIONARIES['001015'] = '土家族';
$DICTIONARIES['001016'] = '哈尼族';
$DICTIONARIES['001017'] = '哈萨克族';
$DICTIONARIES['001018'] = '傣族';
$DICTIONARIES['001019'] = '黎族';
$DICTIONARIES['001020'] = '傈僳族';
$DICTIONARIES['001021'] = '佤族';
$DICTIONARIES['001022'] = '畲族';
$DICTIONARIES['001023'] = '高山族';
$DICTIONARIES['001024'] = '拉祜族';
$DICTIONARIES['001025'] = '水族';
$DICTIONARIES['001026'] = '东乡族';
$DICTIONARIES['001028'] = '景颇族';
$DICTIONARIES['001029'] = '柯尔克孜族';
$DICTIONARIES['001030'] = '土族';
$DICTIONARIES['001031'] = '达斡尔族';
$DICTIONARIES['001032'] = '仫佬族';
$DICTIONARIES['001033'] = '羌族';
$DICTIONARIES['001034'] = '布朗族';
$DICTIONARIES['001035'] = '撒拉族';
$DICTIONARIES['001036'] = '毛难族';
$DICTIONARIES['001037'] = '仡佬族';
$DICTIONARIES['001038'] = '锡伯族';
$DICTIONARIES['001039'] = '阿昌族';
$DICTIONARIES['001040'] = '普米族';
$DICTIONARIES['001041'] = '塔吉克族';
$DICTIONARIES['001042'] = '怒族';
$DICTIONARIES['001043'] = '乌孜别克族';
$DICTIONARIES['001044'] = '俄罗斯族';
$DICTIONARIES['001045'] = '鄂温克族';
$DICTIONARIES['001046'] = '崩龙族';
$DICTIONARIES['001047'] = '保安族';
$DICTIONARIES['001048'] = '裕固族';
$DICTIONARIES['001049'] = '京族';
$DICTIONARIES['001050'] = '塔塔尔族';
$DICTIONARIES['001051'] = '独龙族';
$DICTIONARIES['001052'] = '鄂伦春族';
$DICTIONARIES['001053'] = '赫哲族';
$DICTIONARIES['001054'] = '门巴族';
$DICTIONARIES['001055'] = '珞巴族';
$DICTIONARIES['001056'] = '基诺族';
$DICTIONARIES['001057'] = '穿青人';
$DICTIONARIES['001058'] = '亻革家人';
$DICTIONARIES['001059'] = '纳西族';
$DICTIONARIES['002'] = '性别';
$DICTIONARIES['002001'] = '男';
$DICTIONARIES['002002'] = '女';
$DICTIONARIES['003'] = '行政职务';
$DICTIONARIES['003001'] = 'T';
$DICTIONARIES['003002'] = 'C1';
$DICTIONARIES['003003'] = 'C2';
$DICTIONARIES['003004'] = 'C3';
$DICTIONARIES['003005'] = 'C4';
$DICTIONARIES['003006'] = 'K1';
$DICTIONARIES['003007'] = 'K2';
$DICTIONARIES['003008'] = 'K3';
$DICTIONARIES['003009'] = 'G';
$DICTIONARIES['003010'] = 'J';
$DICTIONARIES['003011'] = 'S';
$DICTIONARIES['004'] = '政治面貌';
$DICTIONARIES['004001'] = '群众';
$DICTIONARIES['004002'] = '共青团员';
$DICTIONARIES['004003'] = '预备党员';
$DICTIONARIES['004004'] = '中共党员';
$DICTIONARIES['004005'] = '民主党派';
$DICTIONARIES['005'] = '学历';
$DICTIONARIES['005001'] = '无';
$DICTIONARIES['005002'] = '中专或相当学历';
$DICTIONARIES['005003'] = '大专或相当学历';
$DICTIONARIES['005005'] = '本科';
$DICTIONARIES['005006'] = '双学士';
$DICTIONARIES['005007'] = '硕士';
$DICTIONARIES['005008'] = '博士';
$DICTIONARIES['005009'] = '博士后';
$DICTIONARIES['005010'] = '其他';
$DICTIONARIES['005011'] = '研究生（未取得学位）';
$DICTIONARIES['005012'] = '高中';
$DICTIONARIES['006'] = '报考等级';
$DICTIONARIES['006001'] = '中级';
$DICTIONARIES['006002'] = '高级';
$DICTIONARIES['007'] = '工种';
$DICTIONARIES['007001'] = '汽车驾驶员';
$DICTIONARIES['007002'] = '汽车修理工';
$DICTIONARIES['007003'] = '船舶甲板设备操作工';
$DICTIONARIES['007004'] = '船舶机工';
$DICTIONARIES['007005'] = '视觉航标工';
$DICTIONARIES['007006'] = '油漆工';
$DICTIONARIES['007007'] = '手工木工';
$DICTIONARIES['007008'] = '焊工';
$DICTIONARIES['007009'] = '管工';
$DICTIONARIES['007010'] = '锅炉操作工';
$DICTIONARIES['007011'] = '筑路机械操作工';
$DICTIONARIES['007012'] = '筑路、养护工';
$DICTIONARIES['007013'] = '通信工';
$DICTIONARIES['007014'] = '混凝土工';
$DICTIONARIES['007015'] = '中小型施工机械操作工';
$DICTIONARIES['007016'] = '土石方机械操作工';
$DICTIONARIES['007017'] = '防水工';
$DICTIONARIES['007018'] = '值班员';
$DICTIONARIES['007019'] = '瓦工';
$DICTIONARIES['007020'] = '垃圾清运工';
$DICTIONARIES['007021'] = '艺工';
$DICTIONARIES['007022'] = '保洁员';
$DICTIONARIES['007023'] = '观赏动物饲养工';
$DICTIONARIES['007024'] = '垃圾处理工';
$DICTIONARIES['007025'] = '花卉园艺工';
$DICTIONARIES['007026'] = '农机修理工';
$DICTIONARIES['007027'] = '农艺工';
$DICTIONARIES['007028'] = '果、茶、桑园艺工';
$DICTIONARIES['007029'] = '家禽饲养工';
$DICTIONARIES['007030'] = '造林更新工';
$DICTIONARIES['007031'] = '兽医';
$DICTIONARIES['007032'] = '养老护理员';
$DICTIONARIES['007033'] = '河道修防工';
$DICTIONARIES['007034'] = '中药提取工';
$DICTIONARIES['007035'] = '眼镜定配工';
$DICTIONARIES['007036'] = '水生动物饲养工';
$DICTIONARIES['007037'] = '尸体火化工';
$DICTIONARIES['007038'] = '钻探灌浆工';
$DICTIONARIES['007039'] = '闸门运行工';
$DICTIONARIES['007040'] = '灌排工程工';
$DICTIONARIES['007041'] = '制剂及医用制品灭菌工';
$DICTIONARIES['007042'] = '医疗器械检修工';
$DICTIONARIES['007043'] = '平版印刷工';
$DICTIONARIES['007044'] = '报刊发行员';
$DICTIONARIES['007045'] = '装订工';
$DICTIONARIES['007046'] = '保育员';
$DICTIONARIES['007047'] = '体育场地工';
$DICTIONARIES['007048'] = '出版物发行员';
$DICTIONARIES['007049'] = '西式面点师';
$DICTIONARIES['007050'] = '平版制版工';
$DICTIONARIES['007051'] = '中式面点师';
$DICTIONARIES['007052'] = '营业员';
$DICTIONARIES['007053'] = '泵站运行工';
$DICTIONARIES['007054'] = '出版物储运员';
$DICTIONARIES['007055'] = '中式烹调师';
$DICTIONARIES['007056'] = '餐厅服务员';
$DICTIONARIES['007057'] = '客房服务员';
$DICTIONARIES['007058'] = '地图制图工';
$DICTIONARIES['007059'] = '大地测量工';
$DICTIONARIES['007060'] = '康乐服务员';
$DICTIONARIES['007061'] = '地籍测绘工';
$DICTIONARIES['007062'] = '工程测量工';
$DICTIONARIES['007063'] = '水文、水井钻探工';
$DICTIONARIES['007064'] = '衡器计量工';
$DICTIONARIES['007065'] = '长度计量工';
$DICTIONARIES['007066'] = '维修电工';
$DICTIONARIES['007067'] = '食品检验工';
$DICTIONARIES['007068'] = '机修钳工';
$DICTIONARIES['007069'] = '无线电装接工';
$DICTIONARIES['007070'] = '工程地质工程施工钻探工';
$DICTIONARIES['007071'] = '电工';
$DICTIONARIES['007072'] = '制冷工';
$DICTIONARIES['007073'] = '废水处理工';
$DICTIONARIES['007074'] = '钳工';
$DICTIONARIES['007075'] = '保管员';
$DICTIONARIES['007076'] = '计算机文字录入处理员';
$DICTIONARIES['007077'] = '凸版印刷工';
$DICTIONARIES['007078'] = '车工';
$DICTIONARIES['007079'] = '收银员';
$DICTIONARIES['007080'] = '动物检疫检验员';
$DICTIONARIES['007081'] = '玻璃切裁工';
$DICTIONARIES['007082'] = '拷贝检片员';
$DICTIONARIES['007083'] = '起重机驾驶员';
$DICTIONARIES['007084'] = '钢筋工';
$DICTIONARIES['007085'] = '制片工';
$DICTIONARIES['007086'] = '塔式起重机驾驶员';
$DICTIONARIES['007087'] = '加工中心操作工';
$DICTIONARIES['007088'] = '材料物理性能检验工';
$DICTIONARIES['007089'] = '爆破工';
$DICTIONARIES['007090'] = '工程电气设备安装调试工';
$DICTIONARIES['007091'] = '无线电调试工';
$DICTIONARIES['007092'] = '高压电气及元件试验工';
$DICTIONARIES['007093'] = '安装起重工';
$DICTIONARIES['007094'] = '办公设备维修工';
$DICTIONARIES['007095'] = '盆景';
$DICTIONARIES['007096'] = '植物保护技术人员';
$DICTIONARIES['007097'] = '假山工';
$DICTIONARIES['007098'] = '家用电子产品维修工';
$DICTIONARIES['007099'] = '制图员';
$DICTIONARIES['007100'] = '铣工';
$DICTIONARIES['007101'] = '镗工';
$DICTIONARIES['007102'] = '机械检查工';
$DICTIONARIES['007103'] = '刨、插工';
$DICTIONARIES['007104'] = '无损探伤工';
$DICTIONARIES['007105'] = '铸造工';
$DICTIONARIES['007106'] = '音像带复制工';
$DICTIONARIES['007107'] = '工业化学分析工';
$DICTIONARIES['007108'] = '金属热处理工';
$DICTIONARIES['007109'] = '锻造工';
$DICTIONARIES['007110'] = '内燃机装配工';
$DICTIONARIES['007111'] = '冷作工';
$DICTIONARIES['007112'] = '三角测量工';
$DICTIONARIES['007113'] = '磨片工';
$DICTIONARIES['007114'] = '海洋浮标工';
$DICTIONARIES['007115'] = '数控车床工';
$DICTIONARIES['007116'] = '锅炉本体检修工';
$DICTIONARIES['007117'] = '建筑材料试验工';
$DICTIONARIES['007118'] = '架子工';
$DICTIONARIES['007119'] = '水文勘测工';
$DICTIONARIES['007120'] = '林木种苗工';
$DICTIONARIES['007121'] = '机构维护工';
$DICTIONARIES['007122'] = '高压线路带电检修工';
$DICTIONARIES['007123'] = '水处理工';
$DICTIONARIES['007124'] = '工具钳工';
$DICTIONARIES['007125'] = '橡胶炼胶';
$DICTIONARIES['007126'] = '物资供应员';
$DICTIONARIES['007127'] = '商品运输员';
$DICTIONARIES['007128'] = '话务员';
$DICTIONARIES['007129'] = '船舶装配工';
$DICTIONARIES['007130'] = '报务员';
$DICTIONARIES['007131'] = '商品采购员';
$DICTIONARIES['007132'] = '摄影师';
$DICTIONARIES['007133'] = '按摩师';
$DICTIONARIES['007134'] = '市话机务员';
$DICTIONARIES['007135'] = '浴池服务员';
$DICTIONARIES['007136'] = '尸体整容工';
$DICTIONARIES['007137'] = '无线电导航机电工';
$DICTIONARIES['007138'] = '美发师';
$DICTIONARIES['007139'] = '剧装工';
$DICTIONARIES['007140'] = '机线员';
$DICTIONARIES['007141'] = '缝纫工';
$DICTIONARIES['007142'] = '实验动物饲养工';
$DICTIONARIES['007143'] = '字画装裱工';
$DICTIONARIES['007144'] = '船舶电工';
$DICTIONARIES['007145'] = '环卫机动车驾驶员';
$DICTIONARIES['007146'] = '纸张整饰工';
$DICTIONARIES['007147'] = '墓地管理员';
$DICTIONARIES['007148'] = '乐器维修工';
$DICTIONARIES['007149'] = '舞台灯光照明工';
$DICTIONARIES['007150'] = '线务员';
$DICTIONARIES['007151'] = '无线电导航定时工';
$DICTIONARIES['007152'] = '医疗器械检验工';
$DICTIONARIES['007153'] = '音响调音员';
$DICTIONARIES['007154'] = '塑料注塑工';
$DICTIONARIES['007155'] = '中药临方制剂员';
$DICTIONARIES['007156'] = '制冷设备维修工';
$DICTIONARIES['007157'] = '装饰美工';
$DICTIONARIES['007158'] = '会计人员';
$DICTIONARIES['007159'] = '泵站机电设备维修';
$DICTIONARIES['007160'] = '灯塔工';
$DICTIONARIES['007161'] = '电梯维修工';
$DICTIONARIES['007162'] = '机电工';
$DICTIONARIES['007163'] = '玻璃灯工';
$DICTIONARIES['007164'] = '排水巡视管理工';
$DICTIONARIES['007165'] = '饲养工';
$DICTIONARIES['007166'] = '汽车检测工';
$DICTIONARIES['007167'] = '绕线工';
$DICTIONARIES['007168'] = '音像发行员';
$DICTIONARIES['007169'] = '污水化验监测工';
$DICTIONARIES['007170'] = '挖掘机驾驶员';
$DICTIONARIES['007171'] = '车辆通行费收费员';
$DICTIONARIES['007172'] = '市政材料库管工';
$DICTIONARIES['007173'] = '泵站电气安装、调试工';
$DICTIONARIES['007174'] = '淡水成鱼饲养';
$DICTIONARIES['007175'] = '海水鱼虾蟹养殖工';
$DICTIONARIES['007176'] = '化工检修工';
$DICTIONARIES['007177'] = '土工试验工';
$DICTIONARIES['007178'] = '商品营业员';
$DICTIONARIES['007179'] = '锅炉水质化验工';
$DICTIONARIES['007180'] = '防雹员';
$DICTIONARIES['007181'] = '暗室师';
$DICTIONARIES['007182'] = '服装设计定制工';
$DICTIONARIES['007183'] = '洗衣师';
$DICTIONARIES['007184'] = '净水工';
$DICTIONARIES['007185'] = '殡仪服务员';
$DICTIONARIES['007186'] = '遗体整容师';
$DICTIONARIES['007188'] = '遗体接运工';
$DICTIONARIES['007189'] = '物探工';
$DICTIONARIES['007190'] = '纺织设备保全工';
$DICTIONARIES['007191'] = '蔬菜加工工';
$DICTIONARIES['007192'] = '拖拉机教师员';
$DICTIONARIES['007193'] = '其他';
$DICTIONARIES['008'] = '工种级别';
$DICTIONARIES['008001'] = '无';
$DICTIONARIES['008002'] = '初级';
$DICTIONARIES['008003'] = '中级';
$DICTIONARIES['008004'] = '高级';
$DICTIONARIES['009'] = '职务级别';
$DICTIONARIES['009001'] = '无';
$DICTIONARIES['009002'] = '办事员';
$DICTIONARIES['009003'] = '科员';
$DICTIONARIES['009004'] = '副科(局)';
$DICTIONARIES['009005'] = '正科(局)';
$DICTIONARIES['009006'] = '副处(县)';
$DICTIONARIES['009007'] = '正处(县)';
$DICTIONARIES['009008'] = '副厅';
$DICTIONARIES['009009'] = '正厅';
$DICTIONARIES['009010'] = '其他';
$DICTIONARIES['009011'] = '正部';
$DICTIONARIES['009012'] = '副部';
$DICTIONARIES['010'] = '个人身份';
$DICTIONARIES['010001'] = '无';
$DICTIONARIES['010002'] = '公务员';
$DICTIONARIES['010003'] = '事业单位人员';
$DICTIONARIES['010004'] = '企业单位人员';
$DICTIONARIES['010005'] = '专业技术人员';
$DICTIONARIES['011'] = '专业技术职称';
$DICTIONARIES['011001'] = '无';
$DICTIONARIES['011002'] = '初级职称';
$DICTIONARIES['011003'] = '中级职称';
$DICTIONARIES['011004'] = '副高级职称';
$DICTIONARIES['011005'] = '正高级职称';
$DICTIONARIES['011006'] = '助理级职称';
$DICTIONARIES['012'] = '专业技术职务';
$DICTIONARIES['012001'] = '无';
$DICTIONARIES['012002'] = '高校教师';
$DICTIONARIES['012003'] = '自然科学研究';
$DICTIONARIES['012004'] = '社会科学研究';
$DICTIONARIES['012005'] = '卫生技术';
$DICTIONARIES['012006'] = '农业技术';
$DICTIONARIES['012007'] = '工程技术';
$DICTIONARIES['012008'] = '经济';
$DICTIONARIES['012009'] = '会计审计';
$DICTIONARIES['012010'] = '统计';
$DICTIONARIES['012011'] = '中专教师';
$DICTIONARIES['012012'] = '技校教师';
$DICTIONARIES['012013'] = '中学教师';
$DICTIONARIES['012014'] = '小学教师';
$DICTIONARIES['012015'] = '档案';
$DICTIONARIES['012016'] = '文物博物群众文化';
$DICTIONARIES['012017'] = '图书资料';
$DICTIONARIES['012018'] = '翻译';
$DICTIONARIES['012019'] = '律师';
$DICTIONARIES['012020'] = '公证员';
$DICTIONARIES['012021'] = '新闻';
$DICTIONARIES['012022'] = '播音';
$DICTIONARIES['012023'] = '出版';
$DICTIONARIES['012024'] = '体育教练';
$DICTIONARIES['012025'] = '船舶';
$DICTIONARIES['012026'] = '艺术';
$DICTIONARIES['012027'] = '工艺美术';
$DICTIONARIES['012028'] = '试验';
$DICTIONARIES['012029'] = '海关';
$DICTIONARIES['012030'] = '飞行';
$DICTIONARIES['013'] = '级别名称';
$DICTIONARIES['013001'] = '无';
$DICTIONARIES['013002'] = '正高级';
$DICTIONARIES['013003'] = '副高级';
$DICTIONARIES['013004'] = '中级';
$DICTIONARIES['013005'] = '助理级';
$DICTIONARIES['013006'] = '员级';
$DICTIONARIES['014'] = '单位性质';
$DICTIONARIES['014001'] = '国有';
$DICTIONARIES['014002'] = '公私合营';
$DICTIONARIES['014003'] = '中外合资';
$DICTIONARIES['014004'] = '外资';
$DICTIONARIES['014005'] = '私营';
$DICTIONARIES['014006'] = '集体';
$DICTIONARIES['014007'] = '股份制';
$DICTIONARIES['014008'] = '高新技术企业';
$DICTIONARIES['014009'] = '一类（全额拨款）事业单位';
$DICTIONARIES['014010'] = '依照公务员管理的事业单位';
$DICTIONARIES['014011'] = '二类（差额拨款）事业单位';
$DICTIONARIES['014012'] = '三类（自收自支）事业单位';
$DICTIONARIES['014013'] = '实行企业化管理的事业单位';
$DICTIONARIES['014014'] = '政府机关';
$DICTIONARIES['014015'] = '党委机关';
$DICTIONARIES['014016'] = '人民团体';
$DICTIONARIES['015'] = '所属领域';
$DICTIONARIES['015001'] = '航空航天';
$DICTIONARIES['015002'] = '石油化工';
$DICTIONARIES['015003'] = '装备制造';
$DICTIONARIES['015004'] = '电子信息';
$DICTIONARIES['015005'] = '生物制药';
$DICTIONARIES['015006'] = '新能源新材料';
$DICTIONARIES['015007'] = '轻工纺织';
$DICTIONARIES['015008'] = '国防科技';
$DICTIONARIES['015009'] = '现代农业';
$DICTIONARIES['015010'] = '现代交通';
$DICTIONARIES['015011'] = '城市规划';
$DICTIONARIES['015012'] = '生态环保';
$DICTIONARIES['015013'] = '教育卫生';
$DICTIONARIES['015014'] = '文化艺术';
$DICTIONARIES['015015'] = '宣传思想';
$DICTIONARIES['015016'] = '防灾减灾和政法';
$DICTIONARIES['015017'] = '金融保险';
$DICTIONARIES['015018'] = '现代物流';
$DICTIONARIES['015019'] = '信息咨询';
$DICTIONARIES['015020'] = '商贸旅游';
$DICTIONARIES['015021'] = '服务外包';
$DICTIONARIES['015022'] = '法律咨询';
$DICTIONARIES['015023'] = '房地产';
$DICTIONARIES['015024'] = '土建工程';
$DICTIONARIES['015025'] = '其他';
$DICTIONARIES['016'] = '政工职称';
$DICTIONARIES['016001'] = '思政研究员';
$DICTIONARIES['016002'] = '高级政工师';
$DICTIONARIES['016003'] = '政工师';
$DICTIONARIES['016004'] = '助理政工师';
$DICTIONARIES['016005'] = '政工员';
$DICTIONARIES['016006'] = '其他';
$DICTIONARIES['016007'] = '无';
$DICTIONARIES['017'] = '单位性质(天津政工)';
$DICTIONARIES['017001'] = '事业单位';
$DICTIONARIES['017002'] = '国有企业';
$DICTIONARIES['017003'] = '民营企业';
$DICTIONARIES['017004'] = '外资企业';
$DICTIONARIES['017005'] = '合资企业';
$DICTIONARIES['017006'] = '其他企业';
$DICTIONARIES['017007'] = '高新技术企业';
$DICTIONARIES['018'] = '审核结果';
$DICTIONARIES['018001'] = '未审核';
$DICTIONARIES['018002'] = '审核通过';
$DICTIONARIES['018003'] = '审核未通过';
$DICTIONARIES['019'] = '工作职称';
$DICTIONARIES['019001'] = '无';
$DICTIONARIES['019002'] = '已取得';
$DICTIONARIES['020'] = '职称专业';
$DICTIONARIES['020001'] = '无';
$DICTIONARIES['020002'] = '其它';
$DICTIONARIES['020003'] = '工程技术';
$DICTIONARIES['020004'] = '爆破工程技术人员';
$DICTIONARIES['020005'] = '爆破员';
$DICTIONARIES['020006'] = '安全员';
$DICTIONARIES['020007'] = '保管员';
$DICTIONARIES['032'] = '显示课件评价';
$DICTIONARIES['032001'] = '开通每个章节都提示';
$DICTIONARIES['032002'] = '开通仅提示一次';
$DICTIONARIES['032003'] = '关闭';
$DICTIONARIES['033'] = '课件详情模块显示';
$DICTIONARIES['033001'] = '相关资料';
$DICTIONARIES['033002'] = '最近学习的学员';
$DICTIONARIES['033003'] = '相关评论';
$DICTIONARIES['033004'] = '相关课程';
$DICTIONARIES['034'] = '课件记录类型';
$DICTIONARIES['034001'] = '培训计划';
$DICTIONARIES['034002'] = '商城';
$DICTIONARIES['035'] = '课件审核状态';
$DICTIONARIES['035001'] = '新建';
$DICTIONARIES['035002'] = '提交审核';
$DICTIONARIES['035003'] = '审核通过';
$DICTIONARIES['035004'] = '审核驳回';
$DICTIONARIES['041'] = '分润方式';
$DICTIONARIES['041001'] = '百分比';
$DICTIONARIES['041002'] = '固定数';
$DICTIONARIES['042'] = '计划类别';
$DICTIONARIES['042001'] = '自建计划';
$DICTIONARIES['042002'] = '上级下发计划';
$DICTIONARIES['043'] = '计划来源';
$DICTIONARIES['043001'] = '本级机构计划';
$DICTIONARIES['043002'] = '下级机构计划';
$DICTIONARIES['045'] = '考核标准';
$DICTIONARIES['045001'] = '学分';
$DICTIONARIES['045002'] = '学时';
$DICTIONARIES['046'] = '支付类型';
$DICTIONARIES['046001'] = '按计划';
$DICTIONARIES['046002'] = '按课程';
$DICTIONARIES['047'] = '支付方式';
$DICTIONARIES['047001'] = '线上支付';
$DICTIONARIES['047002'] = '激活卡';
$DICTIONARIES['047003'] = '线上支付+激活卡';
$DICTIONARIES['047004'] = '线下支付';
$DICTIONARIES['047005'] = '汇付+余额';
$DICTIONARIES['047006'] = '余额';
$DICTIONARIES['048'] = '考核属性';
$DICTIONARIES['048001'] = '免学';
$DICTIONARIES['048002'] = '免试';
$DICTIONARIES['048003'] = '学时控制';
$DICTIONARIES['048004'] = '正常';
$DICTIONARIES['048005'] = '免学免试';
$DICTIONARIES['049'] = '发布方式';
$DICTIONARIES['049001'] = '发布到学员';
$DICTIONARIES['049002'] = '发布到下级主管';
$DICTIONARIES['050'] = '发布范围';
$DICTIONARIES['050001'] = '按组织机构';
$DICTIONARIES['050002'] = '自定义机构';
$DICTIONARIES['050003'] = '指定学员';
$DICTIONARIES['051'] = '培训计划状态';
$DICTIONARIES['051001'] = '创建';
$DICTIONARIES['051002'] = '审核中';
$DICTIONARIES['051003'] = '可发布';
$DICTIONARIES['051004'] = '已发布';
$DICTIONARIES['051005'] = '运行中';
$DICTIONARIES['051006'] = '完成';
$DICTIONARIES['051007'] = '课件延长学习完成';
$DICTIONARIES['051008'] = '审核不通过';
$DICTIONARIES['051009'] = '可发布审核';
$DICTIONARIES['052'] = '选课类型';
$DICTIONARIES['052001'] = '必修';
$DICTIONARIES['052002'] = '选修';
$DICTIONARIES['053'] = '培训计划审核状态';
$DICTIONARIES['053001'] = '待审核';
$DICTIONARIES['053002'] = '已审核';
$DICTIONARIES['054'] = '用户培训计划状态';
$DICTIONARIES['054001'] = '未激活';
$DICTIONARIES['054002'] = '学习中';
$DICTIONARIES['054003'] = '已完成';
$DICTIONARIES['055'] = '培训计划广告位类型';
$DICTIONARIES['055001'] = '计划首页';
$DICTIONARIES['055002'] = '首页分类图片';
$DICTIONARIES['056001'] = '不通过';
$DICTIONARIES['056002'] = '通过';
$DICTIONARIES['057'] = '支持打印证书';
$DICTIONARIES['057001'] = '无';
$DICTIONARIES['057002'] = '考核通过之后';
$DICTIONARIES['057003'] = '学完必修课之后';
$DICTIONARIES['058'] = '培训计划考试限制';
$DICTIONARIES['058001'] = '无';
$DICTIONARIES['058002'] = '学完全部课程再考试';
$DICTIONARIES['061'] = '试题类型';
$DICTIONARIES['061001'] = '单选题';
$DICTIONARIES['061002'] = '多选题';
$DICTIONARIES['061003'] = '填空题';
$DICTIONARIES['061004'] = '判断题';
$DICTIONARIES['061005'] = '主观题';
$DICTIONARIES['061006'] = '匹配题';
$DICTIONARIES['062'] = '题目难度级别';
$DICTIONARIES['062001'] = '极易';
$DICTIONARIES['062002'] = '易';
$DICTIONARIES['062003'] = '中';
$DICTIONARIES['062004'] = '难';
$DICTIONARIES['062005'] = '极难';
$DICTIONARIES['063'] = '订单资源类别';
$DICTIONARIES['063001'] = '课程';
$DICTIONARIES['063002'] = '资料';
$DICTIONARIES['064'] = '学员计划缴费状态';
$DICTIONARIES['064001'] = '激活卡';
$DICTIONARIES['064002'] = '平台余额';
$DICTIONARIES['064003'] = '缴费授权线下';
$DICTIONARIES['064004'] = '缴费授权支付';
$DICTIONARIES['064005'] = '支付宝';
$DICTIONARIES['064006'] = '银行卡';
$DICTIONARIES['064007'] = '微信';
$DICTIONARIES['064009'] = 'ios支付';
$DICTIONARIES['091'] = '考试类型';
$DICTIONARIES['091001'] = '自考';
$DICTIONARIES['091002'] = '统考';
$DICTIONARIES['092'] = '考试信息状态';
$DICTIONARIES['092001'] = '运行中';
$DICTIONARIES['092002'] = '未运行';
$DICTIONARIES['092003'] = '已结束';
$DICTIONARIES['093'] = '成绩显示方式';
$DICTIONARIES['093001'] = '分数';
$DICTIONARIES['093002'] = '通过不通过';
$DICTIONARIES['094'] = '考试通知类型';
$DICTIONARIES['094001'] = '短信';
$DICTIONARIES['094002'] = '公告';
$DICTIONARIES['094003'] = '邮件';
$DICTIONARIES['095'] = '主观题阅卷策略';
$DICTIONARIES['095001'] = '共同阅卷';
$DICTIONARIES['095002'] = '独立阅卷';
$DICTIONARIES['096'] = '试卷展示方式';
$DICTIONARIES['096001'] = '文本';
$DICTIONARIES['096002'] = '图片';
$DICTIONARIES['097'] = '考试对应培训';
$DICTIONARIES['097001'] = '独立考试';
$DICTIONARIES['097002'] = '培训计划下';
$DICTIONARIES['097003'] = '培训班下';
$DICTIONARIES['098'] = '考试设置';
$DICTIONARIES['098001'] = '无';
$DICTIONARIES['098002'] = '学完课程即考试';
$DICTIONARIES['098003'] = '可以直接参加考试';
$DICTIONARIES['098004'] = '学完全部课程再考试';
$DICTIONARIES['099'] = '阅卷状态';
$DICTIONARIES['099001'] = '未阅完';
$DICTIONARIES['099002'] = '阅卷中';
$DICTIONARIES['099003'] = '已阅完';
$DICTIONARIES['100'] = '考试状态';
$DICTIONARIES['100001'] = '已考';
$DICTIONARIES['100002'] = '未考';
$DICTIONARIES['101'] = '题目标记';
$DICTIONARIES['101001'] = '未作答';
$DICTIONARIES['101002'] = '完成';
$DICTIONARIES['101003'] = '标记';
$DICTIONARIES['102'] = '阅卷结果';
$DICTIONARIES['102001'] = '对';
$DICTIONARIES['102002'] = '错';
$DICTIONARIES['102003'] = '部分对错';
$DICTIONARIES['103'] = '考试结果';
$DICTIONARIES['103001'] = '未通过';
$DICTIONARIES['103002'] = '通过';
$DICTIONARIES['103003'] = '待定';
$DICTIONARIES['111'] = '支付平台选择';
$DICTIONARIES['111001'] = '支付宝';
$DICTIONARIES['111002'] = '微信支付';
$DICTIONARIES['1115005'] = '1728694520@qq.com_1';
$DICTIONARIES['112'] = '密码找回方式';
$DICTIONARIES['112001'] = '直接显示';
$DICTIONARIES['112002'] = '手机';
$DICTIONARIES['112003'] = '邮箱';
$DICTIONARIES['113'] = '平台状态';
$DICTIONARIES['113001'] = '启用';
$DICTIONARIES['113002'] = '试用';
$DICTIONARIES['113003'] = '停用';
$DICTIONARIES['115'] = '运营方收款账号';
$DICTIONARIES['115001'] = 'zfbjy@chinanet.gov.cn';
$DICTIONARIES['115002'] = 'caiwu@chinanet.gov.cn';
$DICTIONARIES['115003'] = '3091393662@qq.com';
$DICTIONARIES['115004'] = '873923';
$DICTIONARIES['115006'] = 'gpwhaikou@163.com';
$DICTIONARIES['115007'] = 'nmglpjy@chinanet.gov.cn';
$DICTIONARIES['115008'] = '729991009@qq.com';
$DICTIONARIES['116'] = '运营方微信收款账号';
$DICTIONARIES['116001'] = '1277438701';
$DICTIONARIES['116002'] = '1277438701';
$DICTIONARIES['116003'] = '1322335301';
$DICTIONARIES['117'] = '积分兑换商品状态';
$DICTIONARIES['117001'] = '待兑换';
$DICTIONARIES['117002'] = '已兑换';
$DICTIONARIES['117003'] = '不予兑换';
$DICTIONARIES['123'] = '薪水';
$DICTIONARIES['131'] = '审核状态';
$DICTIONARIES['131001'] = '通过';
$DICTIONARIES['131002'] = '不通过';
$DICTIONARIES['141'] = '讲师级别';
$DICTIONARIES['141001'] = '专家-讲师';
$DICTIONARIES['141002'] = '专家-一般';
$DICTIONARIES['141003'] = '专家-副教授';
$DICTIONARIES['141004'] = '专家-副研究员';
$DICTIONARIES['141005'] = '专家-教授';
$DICTIONARIES['141006'] = '专家-研究员';
$DICTIONARIES['141007'] = '专家-著名教授';
$DICTIONARIES['141008'] = '专家-著名研究员';
$DICTIONARIES['141009'] = '政府官员-科级';
$DICTIONARIES['141010'] = '政府官员-处级';
$DICTIONARIES['141011'] = '政府官员-司局级';
$DICTIONARIES['141012'] = '专家-院士以上';
$DICTIONARIES['141013'] = '政府官员-部级以上';
$DICTIONARIES['141014'] = '企业家-省内知名';
$DICTIONARIES['141015'] = '企业家-国内知名';
$DICTIONARIES['141016'] = '企业家-国际知名';
$DICTIONARIES['141017'] = '政府官员-一般';
$DICTIONARIES['141018'] = '企业家-一般';
$DICTIONARIES['141019'] = '企业家-地方知名';
$DICTIONARIES['151'] = '激活卡批次状态';
$DICTIONARIES['151000'] = '新建';
$DICTIONARIES['151001'] = '等待制卡';
$DICTIONARIES['151002'] = '制卡完成';
$DICTIONARIES['152'] = '激活卡状态';
$DICTIONARIES['152001'] = '未激活';
$DICTIONARIES['152002'] = '已激活';
$DICTIONARIES['153'] = '学习卡批次状态';
$DICTIONARIES['153000'] = '申请中';
$DICTIONARIES['153001'] = '已启用';
$DICTIONARIES['153002'] = '已作废';
$DICTIONARIES['154'] = '学习卡卡详细状态';
$DICTIONARIES['154000'] = '未使用';
$DICTIONARIES['154001'] = '已使用';
$DICTIONARIES['154002'] = '已过期';
$DICTIONARIES['155'] = '激活卡对账方式';
$DICTIONARIES['155001'] = '按售卡对账';
$DICTIONARIES['155002'] = '按激活对账';
$DICTIONARIES['161'] = '角色模板类型';
$DICTIONARIES['161001'] = '运营方';
$DICTIONARIES['161002'] = '培训组织方';
$DICTIONARIES['171'] = '商品格式';
$DICTIONARIES['171001'] = '视频';
$DICTIONARIES['171002'] = '文档';
$DICTIONARIES['171003'] = '商品包';
$DICTIONARIES['171004'] = '第三方';
$DICTIONARIES['172'] = '商品类型';
$DICTIONARIES['172001'] = '课件';
$DICTIONARIES['172002'] = '资料';
$DICTIONARIES['173'] = '商品评价状态';
$DICTIONARIES['173001'] = '正常 ';
$DICTIONARIES['173002'] = '置顶';
$DICTIONARIES['173003'] = '无效';
$DICTIONARIES['174'] = '订单付款状态';
$DICTIONARIES['174001'] = '未付款';
$DICTIONARIES['174002'] = '已付款';
$DICTIONARIES['174004'] = '已退款';
$DICTIONARIES['174005'] = '退款申请中';
$DICTIONARIES['174006'] = '退款失败';
$DICTIONARIES['174007'] = '已取消';
$DICTIONARIES['174008'] = '部分退款';
$DICTIONARIES['174009'] = '已删除';
$DICTIONARIES['175'] = '退款流程';
$DICTIONARIES['175001'] = '没有退款请求';
$DICTIONARIES['175002'] = '请求退款';
$DICTIONARIES['175003'] = '已退款';
$DICTIONARIES['175004'] = '拒绝退款';
$DICTIONARIES['175005'] = '退款中';
$DICTIONARIES['175006'] = '退款失败';
$DICTIONARIES['176'] = '供应商分账方式';
$DICTIONARIES['176001'] = '按定价折扣';
$DICTIONARIES['176002'] = '固定价格';
$DICTIONARIES['176003'] = '免费';
$DICTIONARIES['176004'] = '线下约定';
$DICTIONARIES['177'] = '订单类型';
$DICTIONARIES['177001'] = '培训计划订单';
$DICTIONARIES['177002'] = '课件订单';
$DICTIONARIES['177003'] = '考试订单';
$DICTIONARIES['177004'] = '资料订单';
$DICTIONARIES['177005'] = '融学淘课订单';
$DICTIONARIES['177010'] = '线下报名订单';
$DICTIONARIES['177020'] = '红冲订单';
$DICTIONARIES['177021'] = '组织缴费订单';
$DICTIONARIES['178'] = '学员支付方式';
$DICTIONARIES['178001'] = '激活卡支付';
$DICTIONARIES['178002'] = '支付宝支付';
$DICTIONARIES['178003'] = '银行卡支付';
$DICTIONARIES['178004'] = '余额支付';
$DICTIONARIES['178005'] = '微信支付';
$DICTIONARIES['178006'] = '线下支付';
$DICTIONARIES['178007'] = '汇付支付';
$DICTIONARIES['178009'] = '苹果支付';
$DICTIONARIES['178010'] = '缴费授权支付';
$DICTIONARIES['179001'] = '待支付';
$DICTIONARIES['179002'] = '已取消';
$DICTIONARIES['179003'] = '已支付';
$DICTIONARIES['180'] = '热门搜索页面类型';
$DICTIONARIES['180001'] = '首页';
$DICTIONARIES['180002'] = '最新活动';
$DICTIONARIES['180003'] = '限时特价';
$DICTIONARIES['180004'] = '畅销课程';
$DICTIONARIES['180005'] = '精品课程';
$DICTIONARIES['180006'] = '最新课程';
$DICTIONARIES['180007'] = '教学资料';
$DICTIONARIES['180008'] = '电子书';
$DICTIONARIES['180009'] = '免费试读';
$DICTIONARIES['180100'] = '付费精选';
$DICTIONARIES['181'] = '订单操作类型';
$DICTIONARIES['181001'] = '提交订单';
$DICTIONARIES['181002'] = '付款';
$DICTIONARIES['181003'] = '申请退款';
$DICTIONARIES['181004'] = '批准退款';
$DICTIONARIES['181005'] = '拒绝退款';
$DICTIONARIES['181006'] = '退款完成';
$DICTIONARIES['182'] = '商城广告类型';
$DICTIONARIES['182001'] = '首页轮播图片';
$DICTIONARIES['182002'] = '首页分类图片';
$DICTIONARIES['183'] = '退款订单来源';
$DICTIONARIES['183001'] = '商城订单';
$DICTIONARIES['183002'] = '计划订单';
$DICTIONARIES['184001'] = '计划首页';
$DICTIONARIES['184002'] = '首页分类页面';
$DICTIONARIES['201'] = '培训通知类型';
$DICTIONARIES['201001'] = '培训计划通知';
$DICTIONARIES['201002'] = '考试通知';
$DICTIONARIES['201003'] = '一般通知';
$DICTIONARIES['201004'] = '新闻资讯';
$DICTIONARIES['201005'] = '短信通知';
$DICTIONARIES['202'] = '培训通知状态';
$DICTIONARIES['202001'] = '已发布';
$DICTIONARIES['202002'] = '无效';
$DICTIONARIES['202003'] = '已过期';
$DICTIONARIES['203'] = '培训通知展示方式';
$DICTIONARIES['203001'] = '默认';
$DICTIONARIES['203002'] = '滚动条';
$DICTIONARIES['203003'] = '走马灯';
$DICTIONARIES['204'] = '公告类型';
$DICTIONARIES['204001'] = '培训通知';
$DICTIONARIES['204002'] = '商城通知';
$DICTIONARIES['205'] = '商城通知类型';
$DICTIONARIES['205001'] = '公告';
$DICTIONARIES['205002'] = '特惠';
$DICTIONARIES['205003'] = '新闻';
$DICTIONARIES['211'] = '问卷类型';
$DICTIONARIES['211001'] = '普通问卷';
$DICTIONARIES['211002'] = '考前问卷';
$DICTIONARIES['211003'] = '课后问卷';
$DICTIONARIES['211004'] = '登录后问卷';
$DICTIONARIES['212'] = '问卷题型';
$DICTIONARIES['212001'] = '问答';
$DICTIONARIES['212002'] = '单选';
$DICTIONARIES['212003'] = '多选';
$DICTIONARIES['212004'] = '表格单选';
$DICTIONARIES['212005'] = '表格多选';
$DICTIONARIES['212006'] = '表格填空';
$DICTIONARIES['213'] = '问卷状态';
$DICTIONARIES['213001'] = '新增';
$DICTIONARIES['213002'] = '已发布';
$DICTIONARIES['213003'] = '已关闭';
$DICTIONARIES['221'] = '用户课件状态';
$DICTIONARIES['221001'] = '未学习';
$DICTIONARIES['221002'] = '学习中';
$DICTIONARIES['221003'] = '已学习';
$DICTIONARIES['222'] = '课件格式';
$DICTIONARIES['222001'] = 'SCORM2004';
$DICTIONARIES['222002'] = 'SCORM1.2';
$DICTIONARIES['223'] = '文件类型';
$DICTIONARIES['223001'] = 'PTF.zip';
$DICTIONARIES['224'] = '课件形式';
$DICTIONARIES['224001'] = '试题';
$DICTIONARIES['224002'] = '讲义';
$DICTIONARIES['224003'] = '音视频';
$DICTIONARIES['224004'] = '互动';
$DICTIONARIES['224005'] = '衍生资料';
$DICTIONARIES['225'] = '学习对象';
$DICTIONARIES['225001'] = '其他人员';
$DICTIONARIES['225002'] = '高技能人才';
$DICTIONARIES['225003'] = '农民工';
$DICTIONARIES['225004'] = '全体管理人员';
$DICTIONARIES['225005'] = '军队转业干部';
$DICTIONARIES['225006'] = '事业单位管理人员';
$DICTIONARIES['225007'] = '企业管理人员';
$DICTIONARIES['225008'] = '企业专业技术人员';
$DICTIONARIES['225009'] = '电力运行岗位';
$DICTIONARIES['225010'] = '电力管理岗位';
$DICTIONARIES['225011'] = '电力营销岗位';
$DICTIONARIES['225012'] = '数字媒体';
$DICTIONARIES['225013'] = '建筑可视化';
$DICTIONARIES['225014'] = '影视类';
$DICTIONARIES['225015'] = '室内设计';
$DICTIONARIES['225016'] = '交互设计';
$DICTIONARIES['225017'] = '电视包装';
$DICTIONARIES['225018'] = '领导干部';
$DICTIONARIES['225019'] = '基层公务员';
$DICTIONARIES['225020'] = '新任职公务员';
$DICTIONARIES['225021'] = '行业、部门专业技术人员';
$DICTIONARIES['225022'] = '新录用公务员';
$DICTIONARIES['225023'] = '游戏美术';
$DICTIONARIES['225024'] = '高层次人才';
$DICTIONARIES['225025'] = '全体公务员';
$DICTIONARIES['225026'] = '离退休人员';
$DICTIONARIES['225027'] = '人社系统干部';
$DICTIONARIES['225028'] = '职称、职业资格考试人员';
$DICTIONARIES['225029'] = '急需紧缺人才';
$DICTIONARIES['225030'] = '继续教育人员';
$DICTIONARIES['225031'] = '全体专业技术人员';
$DICTIONARIES['226'] = '课件播放类型';
$DICTIONARIES['226001'] = '支持pc和pad播放';
$DICTIONARIES['226002'] = '仅支持pc播放';
$DICTIONARIES['226003'] = '仅支持pad播放';
$DICTIONARIES['251'] = '线下培训结果';
$DICTIONARIES['251001'] = '通过';
$DICTIONARIES['251002'] = '不通过';
$DICTIONARIES['251003'] = '未审核';
$DICTIONARIES['252'] = '线下审核状态';
$DICTIONARIES['252001'] = '待审核';
$DICTIONARIES['252002'] = '通过';
$DICTIONARIES['252003'] = '不通过';
$DICTIONARIES['261'] = '意见反馈处理状态';
$DICTIONARIES['261001'] = '已处理';
$DICTIONARIES['261002'] = '未处理';
$DICTIONARIES['263'] = '意见反馈来源';
$DICTIONARIES['263001'] = 'iphone';
$DICTIONARIES['263002'] = 'ipad';
$DICTIONARIES['263003'] = 'android_mobile';
$DICTIONARIES['263004'] = 'android_pad';
$DICTIONARIES['263005'] = 'web';
$DICTIONARIES['263006'] = '微信';
$DICTIONARIES['263007'] = 'wap';
$DICTIONARIES['271'] = '发票状态';
$DICTIONARIES['271001'] = '未开';
$DICTIONARIES['271002'] = '已开';
$DICTIONARIES['272'] = '证书资源来源';
$DICTIONARIES['272001'] = '课程';
$DICTIONARIES['272002'] = '线下档案';
$DICTIONARIES['273'] = '获取积分方式';
$DICTIONARIES['273001'] = '登录方式获取积分';
$DICTIONARIES['273002'] = '学完课程获得积分';
$DICTIONARIES['273003'] = '缴费获得积分';
$DICTIONARIES['273004'] = '注册获取积分';
$DICTIONARIES['273005'] = '填写调查问卷获取积分';
$DICTIONARIES['273006'] = '考试通过获取积分';
$DICTIONARIES['274'] = '证书职称系列';
$DICTIONARIES['274000'] = '无';
$DICTIONARIES['274001'] = '高等学校教师';
$DICTIONARIES['274002'] = '中等专业学校教师';
$DICTIONARIES['274003'] = '中学教师';
$DICTIONARIES['274004'] = '小学教师';
$DICTIONARIES['274005'] = '技工学校教师';
$DICTIONARIES['274007'] = '实验技术人员';
$DICTIONARIES['274008'] = '工程技术人员';
$DICTIONARIES['274009'] = '经济专业人员';
$DICTIONARIES['274010'] = '会计专业人员';
$DICTIONARIES['274011'] = '审计专业人员';
$DICTIONARIES['274012'] = '统计专业人员';
$DICTIONARIES['274013'] = '图书资料专业人员';
$DICTIONARIES['274014'] = '文物博物专业人员';
$DICTIONARIES['274015'] = '档案专业人员';
$DICTIONARIES['274016'] = '自然科学研究人员';
$DICTIONARIES['274017'] = '社会科学研究人员';
$DICTIONARIES['274018'] = '体育教练员';
$DICTIONARIES['274019'] = '翻译';
$DICTIONARIES['274020'] = '广播电视播音';
$DICTIONARIES['274021'] = '工艺美术专业人员';
$DICTIONARIES['274022'] = '律师';
$DICTIONARIES['274023'] = '公证员';
$DICTIONARIES['274024'] = '海关专业人员';
$DICTIONARIES['274025'] = '卫生技术人员';
$DICTIONARIES['274026'] = '农业技术人员';
$DICTIONARIES['274027'] = '新闻专业人员';
$DICTIONARIES['274028'] = '出版专业人员';
$DICTIONARIES['274029'] = '艺术专业人员';
$DICTIONARIES['274030'] = '船舶技术人员';
$DICTIONARIES['274031'] = '民用航空飞行技术人员';
$DICTIONARIES['275'] = '证书资格名称';
$DICTIONARIES['275000'] = '无';
$DICTIONARIES['275001'] = '教授';
$DICTIONARIES['275002'] = '主任医师';
$DICTIONARIES['275003'] = '主任药师';
$DICTIONARIES['275004'] = '主任护师';
$DICTIONARIES['275005'] = '主任技师';
$DICTIONARIES['275006'] = '农业技术推广研究员';
$DICTIONARIES['275007'] = '研究馆员';
$DICTIONARIES['275008'] = '研究员';
$DICTIONARIES['275009'] = '高级记者';
$DICTIONARIES['275010'] = '高级编辑';
$DICTIONARIES['275011'] = '国家级教练';
$DICTIONARIES['275012'] = '译审';
$DICTIONARIES['275013'] = '播音指导';
$DICTIONARIES['275014'] = '编审';
$DICTIONARIES['275015'] = '一级律师';
$DICTIONARIES['275016'] = '一级公证员';
$DICTIONARIES['275017'] = '一级编剧（含创作）';
$DICTIONARIES['275018'] = '一级作曲';
$DICTIONARIES['275019'] = '一级导演';
$DICTIONARIES['275020'] = '一级演员';
$DICTIONARIES['275021'] = '一级演奏员';
$DICTIONARIES['275022'] = '一级指挥';
$DICTIONARIES['275023'] = '一级美术师';
$DICTIONARIES['275024'] = '一级舞美设计师';
$DICTIONARIES['275025'] = '副教授';
$DICTIONARIES['275026'] = '高级讲师';
$DICTIONARIES['275027'] = '中学高级教师';
$DICTIONARIES['275028'] = '高级实习指导教师';
$DICTIONARIES['275029'] = '高级实验师';
$DICTIONARIES['275030'] = '副主任医师';
$DICTIONARIES['275031'] = '副主任药师';
$DICTIONARIES['275032'] = '副主任护师';
$DICTIONARIES['275033'] = '副主任技师';
$DICTIONARIES['275034'] = '高级工程师';
$DICTIONARIES['275035'] = '高级经济师';
$DICTIONARIES['275036'] = '高级会计师';
$DICTIONARIES['275037'] = '高级审计师';
$DICTIONARIES['275038'] = '高级统计师';
$DICTIONARIES['275039'] = '高级农艺师';
$DICTIONARIES['275040'] = '高级兽医师';
$DICTIONARIES['275041'] = '高级畜牧师';
$DICTIONARIES['275042'] = '副研究馆员';
$DICTIONARIES['275043'] = '副研究员';
$DICTIONARIES['275044'] = '主任记者';
$DICTIONARIES['275045'] = '主任编辑';
$DICTIONARIES['275046'] = '高级教练';
$DICTIONARIES['275047'] = '副译审';
$DICTIONARIES['275048'] = '主任播音员';
$DICTIONARIES['275049'] = '副编审';
$DICTIONARIES['275050'] = '高级工艺美术师';
$DICTIONARIES['275051'] = '二级律师';
$DICTIONARIES['275052'] = '二级公证员';
$DICTIONARIES['275053'] = '二级编剧（含创作）';
$DICTIONARIES['275054'] = '二级作曲';
$DICTIONARIES['275055'] = '二级导演';
$DICTIONARIES['275056'] = '二级演员';
$DICTIONARIES['275057'] = '二级演奏员';
$DICTIONARIES['275058'] = '二级指挥';
$DICTIONARIES['275059'] = '二级美术师';
$DICTIONARIES['275060'] = '二级舞美设计师';
$DICTIONARIES['275061'] = '主任舞台技师';
$DICTIONARIES['275062'] = '高级关务监督';
$DICTIONARIES['275063'] = '高级船长';
$DICTIONARIES['275064'] = '高级轮机长';
$DICTIONARIES['275065'] = '高级电机员';
$DICTIONARIES['275066'] = '高级报务员';
$DICTIONARIES['275067'] = '一级飞行员';
$DICTIONARIES['275068'] = '一级领航员';
$DICTIONARIES['275069'] = '一级飞行通信员';
$DICTIONARIES['275070'] = '一级飞行机械员';
$DICTIONARIES['275071'] = '讲师';
$DICTIONARIES['275072'] = '中学一级教师';
$DICTIONARIES['275073'] = '小学高级教师';
$DICTIONARIES['275074'] = '讲师';
$DICTIONARIES['275075'] = '一级实习指导教师';
$DICTIONARIES['275076'] = '实验师';
$DICTIONARIES['275077'] = '主治（管）医师';
$DICTIONARIES['275078'] = '主管药师';
$DICTIONARIES['275079'] = '主管护师';
$DICTIONARIES['275080'] = '主管技师';
$DICTIONARIES['275081'] = '工程师';
$DICTIONARIES['275082'] = '经济师';
$DICTIONARIES['275083'] = '会计师';
$DICTIONARIES['275084'] = '审计师';
$DICTIONARIES['275085'] = '统计师';
$DICTIONARIES['275086'] = '农艺师';
$DICTIONARIES['275087'] = '兽医师';
$DICTIONARIES['275088'] = '畜牧师';
$DICTIONARIES['275089'] = '馆员';
$DICTIONARIES['275090'] = '助理研究员';
$DICTIONARIES['275091'] = '记者';
$DICTIONARIES['275092'] = '编辑';
$DICTIONARIES['275093'] = '一级教练';
$DICTIONARIES['275094'] = '翻译';
$DICTIONARIES['275095'] = '一级播音员';
$DICTIONARIES['275096'] = '技术编辑';
$DICTIONARIES['275097'] = '一级校对';
$DICTIONARIES['275098'] = '工艺美术师';
$DICTIONARIES['275099'] = '三级律师';
$DICTIONARIES['275100'] = '三级公证员';
$DICTIONARIES['275101'] = '三级编剧（含创作）';
$DICTIONARIES['275102'] = '三级作曲';
$DICTIONARIES['275103'] = '三级导演';
$DICTIONARIES['275104'] = '三级演员';
$DICTIONARIES['275105'] = '三级演奏员';
$DICTIONARIES['275106'] = '三级指挥';
$DICTIONARIES['275107'] = '三级美术师';
$DICTIONARIES['275108'] = '三级舞美设计师';
$DICTIONARIES['275109'] = '舞台技师';
$DICTIONARIES['275110'] = '关务监督';
$DICTIONARIES['275111'] = '船长、大副';
$DICTIONARIES['275112'] = '轮机长、大管轮';
$DICTIONARIES['275113'] = '通用、一等电机员';
$DICTIONARIES['275114'] = '通用、一等报务员';
$DICTIONARIES['275115'] = '二级飞行员';
$DICTIONARIES['275116'] = '二级领航员';
$DICTIONARIES['275117'] = '二级飞行通信员';
$DICTIONARIES['275118'] = '二级飞行机械员';
$DICTIONARIES['275119'] = '助教';
$DICTIONARIES['275120'] = '助理讲师';
$DICTIONARIES['275121'] = '中学二级教师';
$DICTIONARIES['275122'] = '小学一级教师';
$DICTIONARIES['275123'] = '二级实习指导教师';
$DICTIONARIES['275124'] = '助理实验师';
$DICTIONARIES['275125'] = '医师';
$DICTIONARIES['275126'] = '药师';
$DICTIONARIES['275127'] = '护师';
$DICTIONARIES['275128'] = '技师';
$DICTIONARIES['275129'] = '助理工程师';
$DICTIONARIES['275130'] = '助理经济师';
$DICTIONARIES['275131'] = '助理会计师';
$DICTIONARIES['275132'] = '助理审计师';
$DICTIONARIES['275133'] = '助理统计师';
$DICTIONARIES['275134'] = '助理农艺师';
$DICTIONARIES['275135'] = '助理兽医师';
$DICTIONARIES['275136'] = '助理畜牧师';
$DICTIONARIES['275137'] = '助理馆员';
$DICTIONARIES['275138'] = '研究实习员';
$DICTIONARIES['275139'] = '助理记者';
$DICTIONARIES['275140'] = '助理编辑';
$DICTIONARIES['275141'] = '二级教练';
$DICTIONARIES['275142'] = '助理翻译';
$DICTIONARIES['275143'] = '二级播音员';
$DICTIONARIES['275144'] = '助理技术编辑';
$DICTIONARIES['275145'] = '二级校对';
$DICTIONARIES['275146'] = '助理工艺美术师';
$DICTIONARIES['275147'] = '四级律师';
$DICTIONARIES['275148'] = '四级公证员';
$DICTIONARIES['275149'] = '四级编剧（含创作）';
$DICTIONARIES['275150'] = '四级作曲';
$DICTIONARIES['275151'] = '四级导演';
$DICTIONARIES['275152'] = '四级演员';
$DICTIONARIES['275153'] = '四级演奏员';
$DICTIONARIES['275154'] = '四级指挥';
$DICTIONARIES['275155'] = '美术员';
$DICTIONARIES['275156'] = '四级舞美设计员';
$DICTIONARIES['275157'] = '舞台技术员';
$DICTIONARIES['275158'] = '助理关务监督';
$DICTIONARIES['275159'] = '二副';
$DICTIONARIES['275160'] = '二管轮';
$DICTIONARIES['275161'] = '二等电机员';
$DICTIONARIES['275162'] = '二等报务员';
$DICTIONARIES['275163'] = '三级飞行员';
$DICTIONARIES['275164'] = '三级领航员';
$DICTIONARIES['275165'] = '三级飞行通信员';
$DICTIONARIES['275166'] = '三级飞行机械员';
$DICTIONARIES['275167'] = '教员';
$DICTIONARIES['275168'] = '中学三级教师';
$DICTIONARIES['275169'] = '小学二级、小学三级教师';
$DICTIONARIES['275170'] = '教员';
$DICTIONARIES['275171'] = '三级实习指导教师';
$DICTIONARIES['275172'] = '实验员';
$DICTIONARIES['275173'] = '医士';
$DICTIONARIES['275174'] = '药士';
$DICTIONARIES['275175'] = '护士';
$DICTIONARIES['275176'] = '技士';
$DICTIONARIES['275177'] = '技术员';
$DICTIONARIES['275178'] = '经济员';
$DICTIONARIES['275179'] = '会计员';
$DICTIONARIES['275180'] = '审计员';
$DICTIONARIES['275181'] = '统计员';
$DICTIONARIES['275182'] = '农业技术员';
$DICTIONARIES['275183'] = '兽医技术员';
$DICTIONARIES['275184'] = '畜牧技术员';
$DICTIONARIES['275185'] = '管理员';
$DICTIONARIES['275186'] = '文博管理员';
$DICTIONARIES['275187'] = '档案管理员';
$DICTIONARIES['275188'] = '三级教练';
$DICTIONARIES['275189'] = '三级播音员';
$DICTIONARIES['275190'] = '技术设计员';
$DICTIONARIES['275191'] = '三级校对';
$DICTIONARIES['275192'] = '工艺美术员';
$DICTIONARIES['275193'] = '律师助理';
$DICTIONARIES['275194'] = '公证员助理';
$DICTIONARIES['275195'] = '关务员';
$DICTIONARIES['275196'] = '三副';
$DICTIONARIES['275197'] = '三管轮';
$DICTIONARIES['275198'] = '三等电机员';
$DICTIONARIES['275199'] = '限用报务员';
$DICTIONARIES['275200'] = '四级飞行员';
$DICTIONARIES['275201'] = '四级领航员';
$DICTIONARIES['275202'] = '四级飞行通信员';
$DICTIONARIES['275203'] = '四级飞行机械员';
$DICTIONARIES['276'] = '管理员缴费审核状态';
$DICTIONARIES['276001'] = '新建';
$DICTIONARIES['276002'] = '待审核';
$DICTIONARIES['276003'] = '审核通过';
$DICTIONARIES['276004'] = '审核不通过';
$DICTIONARIES['277'] = '管理员充值操作类型';
$DICTIONARIES['277001'] = '充值';
$DICTIONARIES['277002'] = '退款';
$DICTIONARIES['277003'] = '修正';
$DICTIONARIES['278'] = '管理员充值状态';
$DICTIONARIES['278001'] = '申请中';
$DICTIONARIES['278002'] = '驳回';
$DICTIONARIES['278003'] = '充值完成';
$DICTIONARIES['281'] = '视频状态';
$DICTIONARIES['281001'] = '停用';
$DICTIONARIES['281002'] = '正常';
$DICTIONARIES['281003'] = '转码处理中';
$DICTIONARIES['281004'] = '转码失败';
$DICTIONARIES['282'] = '视频类型';
$DICTIONARIES['282001'] = '视频';
$DICTIONARIES['282002'] = '教学';
$DICTIONARIES['283'] = '视频清晰度';
$DICTIONARIES['283001'] = '流畅';
$DICTIONARIES['283002'] = '标清';
$DICTIONARIES['283003'] = '高清';
$DICTIONARIES['283004'] = '超清';
$DICTIONARIES['283005'] = '源视频';
$DICTIONARIES['284'] = '视频包状态';
$DICTIONARIES['284001'] = '停用';
$DICTIONARIES['284002'] = '启用';
$DICTIONARIES['285'] = '视频转码状态';
$DICTIONARIES['285001'] = '未转码';
$DICTIONARIES['285002'] = '转码中';
$DICTIONARIES['285003'] = '已转码';
$DICTIONARIES['285004'] = '转码失败';
$DICTIONARIES['286'] = '视频语言';
$DICTIONARIES['286001'] = '中文';
$DICTIONARIES['286002'] = '英文';
$DICTIONARIES['286003'] = '德文';
$DICTIONARIES['286004'] = '俄文';
$DICTIONARIES['287'] = '课件云课件状态';
$DICTIONARIES['287001'] = '未发布';
$DICTIONARIES['287002'] = '审核中';
$DICTIONARIES['287003'] = '已发布';
$DICTIONARIES['287004'] = '驳回';
$DICTIONARIES['287005'] = '已下架';
$DICTIONARIES['288'] = '课件云课件类型';
$DICTIONARIES['288001'] = '视频课';
$DICTIONARIES['288002'] = '标准scorm';
$DICTIONARIES['289'] = '课件云课件资源类型';
$DICTIONARIES['289001'] = '视频';
$DICTIONARIES['289002'] = '资料';
$DICTIONARIES['289003'] = 'html(zip包)';
$DICTIONARIES['289004'] = 'scorm章节';
$DICTIONARIES['290'] = '课件云资料类型';
$DICTIONARIES['290001'] = '教材';
$DICTIONARIES['290002'] = '教辅';
$DICTIONARIES['290003'] = '其他';
$DICTIONARIES['300'] = '特殊退款类型';
$DICTIONARIES['300001'] = '财务退款';
$DICTIONARIES['301'] = '考试来源';
$DICTIONARIES['301001'] = '自系统';
$DICTIONARIES['301002'] = '考试云';
$DICTIONARIES['302'] = '身份类别';
$DICTIONARIES['302001'] = '高级';
$DICTIONARIES['302002'] = '中级';
$DICTIONARIES['302003'] = '初级';
$DICTIONARIES['303'] = '工种类别';
$DICTIONARIES['303001'] = '爆破员';
$DICTIONARIES['303002'] = '安全员';
$DICTIONARIES['303003'] = '保管员';
$DICTIONARIES['310'] = '政工岗位资格注册';
$DICTIONARIES['310001'] = '党组织负责人';
$DICTIONARIES['310002'] = '组织部门工作人员';
$DICTIONARIES['310003'] = '宣传部门工作人员';
$DICTIONARIES['310004'] = '统战部门工作人员';
$DICTIONARIES['310005'] = '纪检部门工作人员';
$DICTIONARIES['310006'] = '党委办公室工作人员';
$DICTIONARIES['310007'] = '党委研究室工作人员';
$DICTIONARIES['310008'] = '工会工作人员';
$DICTIONARIES['310009'] = '共青团工作人员';
$DICTIONARIES['310010'] = '保卫部门工作人员';
$DICTIONARIES['310011'] = '人事部门工作人员';
$DICTIONARIES['310012'] = '计划生育部门工作人员';
$DICTIONARIES['310013'] = '文明办工作人员';
$DICTIONARIES['310014'] = '老干部工作人员';
$DICTIONARIES['310015'] = '人民调解工作人员';
$DICTIONARIES['310016'] = '人民武装工作人员';
$DICTIONARIES['310017'] = '行政监察工作政工人员';
$DICTIONARIES['310018'] = '分管政工行政领导副职';
$DICTIONARIES['310019'] = '再就业办公室工作人员';
$DICTIONARIES['310020'] = '人力资源部门工作人员';
$DICTIONARIES['310021'] = '劳服保障部门工作人员';
$DICTIONARIES['310022'] = '托管中心政工人员';
$DICTIONARIES['310023'] = '维稳办公室工作人员';
$DICTIONARIES['310024'] = '防范邪教工作人员';
$DICTIONARIES['310025'] = '治安综合治理政工人员';
$DICTIONARIES['310026'] = '文化中心政工人员';
$DICTIONARIES['310027'] = '文化艺术中心政工人员';
$DICTIONARIES['310028'] = '广播电视政工人员';
$DICTIONARIES['310029'] = '新经济组织政工人员';
$DICTIONARIES['310030'] = '社区党组织成员';
$DICTIONARIES['310031'] = '其他';
$DICTIONARIES['320'] = '培训考核设置';
$DICTIONARIES['3200001'] = '考核专业课';
$DICTIONARIES['3200002'] = '考核公共课';
$DICTIONARIES['3200003'] = '考核专业课+公需课';
$DICTIONARIES['3200004'] = '按公需课+专业课考核总学时';
$DICTIONARIES['321'] = '资源审核状态';
$DICTIONARIES['321001'] = '待提交';
$DICTIONARIES['321002'] = '待审核';
$DICTIONARIES['321003'] = '审核通过';
$DICTIONARIES['321004'] = '审核驳回';
$DICTIONARIES['321005'] = '无效';
$DICTIONARIES['322'] = '计划报名状态';
$DICTIONARIES['322001'] = '待确认';
$DICTIONARIES['322002'] = '已确认';
$DICTIONARIES['322003'] = '已取消';
$DICTIONARIES['323'] = '教学资源类型';
$DICTIONARIES['323001'] = '硬件资源';
$DICTIONARIES['323002'] = '软件资源';
$DICTIONARIES['324'] = '收藏资源类型';
$DICTIONARIES['324001'] = '课程';
$DICTIONARIES['324002'] = '教师';
$DICTIONARIES['324003'] = '培训班';
$DICTIONARIES['325'] = '基地类型';
$DICTIONARIES['325001'] = '部委';
$DICTIONARIES['325002'] = '地方行政单位';
$DICTIONARIES['326'] = '基地课程讨论状态';
$DICTIONARIES['326001'] = '未处理';
$DICTIONARIES['326002'] = '正常';
$DICTIONARIES['326003'] = '已屏蔽';
$DICTIONARIES['327'] = '用户操作类型';
$DICTIONARIES['327001'] = '添加收藏';
$DICTIONARIES['327002'] = '添加到购物车';

function getDicNameById(id) {
    return $DICTIONARIES[id];
}
/**
 *返回VUE模板对象
 */
export default {
    getDicNameById:function  (id){
        return $DICTIONARIES[id];
    }
}


// WEBPACK FOOTER //
// ./src/js/dictionary.js